import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';

import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
//import IconButton from '@material-ui/core/IconButton';
//import PlayArrowIcon from '@material-ui/icons/PlayArrow';
//import PauseIcon from '@material-ui/icons/Pause';
//import ArrowBackIcon from '@material-ui/icons/ArrowBack';
//import ArrowForwardIcon from '@material-ui/icons/ArrowForward';

const styles = theme => ({
  stepper: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    //background: theme.palette.background.default,
    backgroundColor: 'rgba(255,255,255,0)!important',
    padding: 8,
    width:'100%', 
  },
  /* Styles applied to the dots container if `variant="dots"`. */
  dots: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '100%',
  },
  dotContainer: {
    [theme.breakpoints.down('sm')]: {
      width: '10px',
      height: '30px',
      margin: '0 calc((100% - 240px) / 48)',
    },
    [theme.breakpoints.up('md')]: {
      width: '20px',
      height: '40px',
      margin: '0 calc((100% - 480px) / 48)',
    },
  },
  /* Styles applied to each dot if `variant="dots"`. */
  dot: {
    backgroundColor: '#d5d5d5',
    borderRadius: '50%',
    [theme.breakpoints.down('sm')]: {
      width: '10px',
      height: '10px',
      margin: '0 calc((100% - 240px) / 48)',
    },
    [theme.breakpoints.up('md')]: {
      width: '20px',
      height: '20px',
      margin: '0 calc((100% - 480px) / 48)',
    },
  },
  hourContainer: {
    textAlign: 'center',
    paddingTop: '5px',
    height: '25px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '0.7em',
      width: '10px',

      margin: '0 calc((100% - 240px) / 48)',
    },
    [theme.breakpoints.up('md')]: {
      fontSize: '0.9em',
      width: '20px',
      margin: '0 calc((100% - 480px) / 48)',
    },

  },
  /* Styles applied to a dot if `variant="dots"` and this is the active step. */
  dotActive: {
    backgroundColor: theme.palette.primary.main,
  },
  controlContainer: {
    justifyContent: 'center',
    alignContent: 'center',
  },
  imageContainer: {
    //position:'absolute',
    //border:'1px solid black',
    width: '48px',
    height: '48px',
    //clipPath: 'circle(35px at 50% 50%)',
    justifyContent: 'center',
    alignContent: 'center',
    /*
    [theme.breakpoints.down('xs')]: {
      left:'30px',
      top:'250px',
      width:'45px',
      height:'45px',
    },
    [theme.breakpoints.up('sm')]: {
      left:'40px',
      top:'300px',
      width:'40px',
      height:'40px',
    },
    [theme.breakpoints.up('md')]: {
      width:'80px',
      height:'80px',
    },
    [theme.breakpoints.up('lg')]: {
      width:'180px',
      height:'140px',
      clipPath: 'ellipse(80px 60px at 50% 45%)',
    },
    */
  },

  hoverState: {
    '&:hover': {
      cursor: 'pointer',
      //background:'#f3f3f3',//background override hides svg
      border: '2px solid black',
    },
  },
  playRed: {
    background: 'url("/images/spw_video_control/play_green.svg")',
  },
  playGrey: {
    background: 'url("/images/spw_video_control/play_grey.svg")',
  },
  pauseRed: {
    background: 'url("/images/spw_video_control/pause_green.svg")',
  },
  pauseGrey: {
    background: 'url("/images/spw_video_control/pause_grey.svg")',
  },
  leftRed: {
    background: 'url("/images/spw_video_control/backward_green.svg")',
  },
  leftGrey: {
    background: 'url("/images/spw_video_control/backward_grey.svg")',
  },
  rightRed: {
    background: 'url("/images/spw_video_control/forward_green.svg")',
  },
  rightGrey: {
    background: 'url("/images/spw_video_control/forward_grey.svg")',
  },
  // notice that selectorImage class must be placed after urls for containing adequately
  selectorImage: {
    //border:'1px solid red',
    backgroundSize: 'contain',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center center!important',
    width: '20px',
    maxWidth: '20px',
    height: 0,
    minHeight: '22px',
    //minHeight: '24px',

    //width:'24px',
    //height:'24px',
    //marginTop:'12px',
  },
});


let isIE = /*@cc_on!@*/false || !!document.documentMode;

//let initialPlayingState=isIE?false:true
let initialPlayingState = false
class VideoControl extends React.Component {
  constructor(props) {
    super(props)

    this.pauseMovement = this.pauseMovement.bind(this);
    this.playMovement = this.playMovement.bind(this);
  }

  state = {
    playing: initialPlayingState,
  }

  pauseMovement() {
    this.setState((previousState, props) => {
      return {
        playing: false
      }
    })
    this.props.setPlayingState(false)
  }

  playMovement() {
    this.setState((previousState, props) => {
      return {
        playing: true
      }
    })
    this.props.setPlayingState(true)
  }

  render() {
    const { classes } = this.props;

    const activeStep = this.props.activeStep;
    const totalSteps = this.props.data.length;
    let activeColor = this.props.activeColor

    let hourCounter = 0

    let shortMonths_en = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
    let shortMonths_fr = ["jan", "fev", "mar", "avr", "mai", "jui", "jui", "aou", "sep", "oct", "nov", "dec"]
    let shortMonths_nl = ["jan", "feb", "maa", "apr", "mei", "jun", "jul", "aug", "sep", "okt", "nov", "dec"]

    return (
      <Grid container>
        <Grid item container xs={12} sm={9}>
          <Paper square elevation={0} className={classes.stepper} style={{ marginTop: (window.innerWidth > 1280 && this.props.currentMode === 'realtime' ? '20px' : '20px') }}>
            <div className={classes.dots}>
              {[...new Array(totalSteps)].map((_, step) => {
                hourCounter++;
                return (<div key={step} className={classes.dotContainer}>
                  <div className={classes.dot} style={(step === activeStep ? { backgroundColor: activeColor } : {})} />
                  <div className={classes.hourContainer}>{this.props.currentMode === 'realtime' ?
                    ((hourCounter - 1) % 6 === 0 ?
                      (((hourCounter - 1) < 10 ? ("0" + (hourCounter - 1)) : (hourCounter - 1)) + (this.props.lang === "de"?':00':'h')) :
                      ' '
                    ) :
                    (this.props.lang === "en" ? shortMonths_en[hourCounter - 1] :
                      (this.props.lang === "fr" ? shortMonths_fr[hourCounter - 1] : shortMonths_nl[hourCounter - 1])
                    )
                  }
                  </div>
                </div>);
              })}
            </div>
          </Paper>
        </Grid>
        <Grid item container xs={12} sm={3} style={{ margin: '0 auto' }} className={classes.controlContainer}>
          <Grid item container xs={3} className={classes.imageContainer + ' ' + (this.state.playing ? '' : classes.hoverState)}>
            <div
              className={classes.leftGrey + ' ' + classes.selectorImage}
              onClick={this.state.playing ? null : (() => this.props.changeActiveStep(activeStep === 0 ? (totalSteps - 1) : (activeStep - 1)))}
            />
          </Grid>
          <Grid item container xs={3} className={classes.imageContainer + ' ' + (this.state.playing ? classes.hoverState : '')}>
            <div
              className={(this.state.playing ? classes.pauseGrey : classes.pauseRed) + ' ' + classes.selectorImage}
              onClick={this.state.playing ? this.pauseMovement : null}
            />
          </Grid>
          <Grid item container xs={3} className={classes.imageContainer + ' ' + (this.state.playing ? '' : classes.hoverState)}>
            {
              <div
                className={(this.state.playing ? classes.playRed : classes.playGrey) + ' ' + classes.selectorImage}
                onClick={this.state.playing ? null : this.playMovement}
              />
            }
          </Grid>
          <Grid item container xs={3} className={classes.imageContainer + ' ' + (this.state.playing ? '' : classes.hoverState)}>
            <div
              className={classes.rightGrey + ' ' + classes.selectorImage}
              onClick={this.state.playing ? null : (() => this.props.changeActiveStep((activeStep + 1) % parseInt(totalSteps)))}
            />
          </Grid>
        </Grid>
      </Grid>
    );
  }
}

VideoControl.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(VideoControl);